// extracted by mini-css-extract-plugin
module.exports = {"root":"TableHeading_root__2S4pB","clinicsSelect":"TableHeading_clinicsSelect__2n-8b"};